import axios from '../../../../utils/api'
import modulo from '@/utils/modulo'

const actions = {

  async findMunicipiosByUf ({ commit }, codigoEstado) {
    const municipios = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado
      },
      loader: false
    })
    return municipios
  },

  async findMunicipiosByEstadoAtualPromise ({ commit }) {
    return axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado: (process.env.ESTADO).toUpperCase()
      },
      loader: false
    })
  },

  async findMunicipiosByEstadoAtual ({ commit }) {
    const municipios = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado: (process.env.ESTADO).toUpperCase()
      },
      loader: false
    })
    return municipios
  },

  async findMunicipioById ({ commit }, municipioId) {
    const municipio = await axios({
      method: 'get',
      url: modulo.PUBLICO + `/findMunicipio/${municipioId}`,
      loader: false
    })
    return municipio
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/seguranca/municipios.js